"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import classNames from "classnames";
function ToolbarLink(props) {
  const { icon, enabled, action, href, title, active, label } = props;
  const className = {
    "icon--inactive": !enabled,
    "icon--highlight": active
  };
  const iconClassName = "icon-" + icon;
  className[iconClassName] = true;
  const labelElement = label ? /* @__PURE__ */ jsx("span", { children: label }) : "";
  return /* @__PURE__ */ jsxs(
    "a",
    {
      "data-component": "ToolbarLink",
      href,
      onClick: enabled ? action : void 0,
      title,
      children: [
        /* @__PURE__ */ jsx("i", { className: classNames(className) }),
        labelElement
      ]
    }
  );
}
export default ToolbarLink;
